import './styles/index.scss';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';

import { initSentry } from './configs/sentry';
import { Root } from './pages/Root';

initSentry();

createRoot(document.getElementById('root') as HTMLElement, {
  onUncaughtError: (error, errorInfo) => {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
      tags: { errorType: 'uncaught' },
    });
  },
  onCaughtError: (error, errorInfo) => {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
      tags: { errorType: 'caught' },
    });
  },
  onRecoverableError: (error, errorInfo) => {
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo.componentStack },
      tags: { errorType: 'recoverable' },
    });
  },
}).render(<Root />);
